import React from 'react';
import { useGetClientAccountOperationsQuery } from '../services/auth/authApi';
import { useNavigate } from 'react-router-dom';

const ClientAccountOperationsPage = () => {
  const navigate = useNavigate();
  
  const { data: operationsData, isLoading, error } = useGetClientAccountOperationsQuery();

  const totalCount = operationsData?.count || 0;

  return (
    <div className="w-full">
      {/* Header */}
      <div className="bg-[#1a3a3a] px-6 py-4 flex justify-between items-center mb-6">
        <h1 className="text-white text-2xl font-medium">Operations ( {totalCount} )</h1>
        <button
          onClick={() => navigate(-1)}
          className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded font-medium"
        >
          Back
        </button>
      </div>

      {/* Content */}
      <div className="">
        {isLoading ? (
          <div className="text-center py-16">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
            <p className="mt-4 text-gray-600">Loading...</p>
          </div>
        ) : error ? (
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <p className="text-red-600 text-lg">Error loading operations</p>
          </div>
        ) : operationsData?.data ? (
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-400">
                <thead>
                  <tr className="bg-[#1a3a3a] text-white">
                    <th className="border border-gray-400 px-4 py-3 text-left text-sm font-medium whitespace-nowrap">Date</th>
                    <th className="border border-gray-400 px-4 py-3 text-left text-sm font-medium whitespace-nowrap">Operation</th>
                    <th className="border border-gray-400 px-4 py-3 text-left text-sm font-medium whitespace-nowrap">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {operationsData.data && operationsData.data.length > 0 ? (
                    operationsData.data.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-50 border-b border-gray-200">
                        <td className="border border-gray-400 px-4 py-3 text-sm whitespace-nowrap">
                          {item.date || '-'}
                        </td>
                        <td className="border border-gray-400 px-4 py-3 text-sm whitespace-nowrap">
                          {item.operation || '-'}
                        </td>
                        <td className="border border-gray-400 px-4 py-3 text-sm">
                          {item.description || '-'}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="border border-gray-400 px-4 py-8 text-center text-gray-500">
                        No operations available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="text-center py-16 text-gray-500 text-lg">
            No data available
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientAccountOperationsPage;
